module.exports = require("@finance/sui/lib/directives/wrap-class");